import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { DataTableModule } from "angular-6-datatable-cc";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SquareLoadingComponent } from './square-loading/square-loading.component';


@NgModule({
  declarations: [
    AppComponent,
    SquareLoadingComponent,
    

    
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    DataTableModule,
  ],

  providers: [],

  bootstrap: [AppComponent]
})

export class AppModule { }
